import React from 'react';

import ArrowDownwardIcon from '@edna/icons/arrowDownward.svg';
import ArrowUpwardIcon from '@edna/icons/arrowUpward.svg';

import * as S from './style';
import type {TTdProps, TThProps} from './style';

enum ESortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

type TProps = {
  children?: React.ReactNode;
  onClick?: TEmptyFunction;
  align?: 'left' | 'center' | 'right';
  sortable?: boolean;
  sortDirection?: ESortDirection;
  className?: string;
};

const AscendingIcon = React.memo(() => (
  <S.Icon role="img" title="ascending-icon" as={ArrowUpwardIcon} />
));
const DescendingIcon = React.memo(() => (
  <S.Icon role="img" title="descending-icon" as={ArrowDownwardIcon} />
));

const Th = React.memo<TProps>(
  ({children, sortDirection, sortable, onClick, align = 'left', className}) => {
    const [hovered, setHovered] = React.useState(false);

    const renderIcon = () => {
      if (sortDirection !== undefined) {
        return sortDirection === ESortDirection.DESC ? <DescendingIcon /> : <AscendingIcon />;
      }

      if (sortable && hovered) {
        return <AscendingIcon />;
      }

      return null;
    };

    return (
      <S.Th
        align={align}
        onClick={onClick}
        className={className}
        sortable={sortable}
        sortDirection={sortDirection}
        onMouseLeave={() => setHovered(false)}
        onMouseEnter={() => setHovered(true)}
      >
        {children}
        {renderIcon()}
      </S.Th>
    );
  },
);

export const {Tr, Td, Table, getTableCellWidth} = S;
export {Th, ESortDirection};

export type {TTdProps, TThProps};
